module.exports = __webpack_public_path__ + "e22557079f3d43c88486a9077abf8189.svg";